var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as FilterOptionFactory from "../../classes/definitions/product/filterOption";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import FilterOptionsList from '../../components/FilterOptions/FilterOptionsList/FilterOptionsList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./FilterOptionsReduxProps";
var FilterOptions = /** @class */ (function (_super) {
    __extends(FilterOptions, _super);
    function FilterOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentId = '-1';
        _this.state = {
            data: []
        };
        _this.getAllFilterOptions = function () {
            _this.api.getFilterOptions(_this.parentId)
                .then(function (response) {
                var values = FilterOptionFactory.createFilterOptions(response.data);
                _this.setState({ data: values });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим филтрите.', _this.props.history);
            });
        };
        _this.toNewFilterOption = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.filterOption.path);
        };
        _this.toEditFilterOption = function (selectedId) {
            if (selectedId !== '-1') {
                _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.filterOption.path + ("/" + selectedId));
            }
        };
        _this.toParentProduct = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    FilterOptions.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.id', '-1');
        if (this.parentId !== '-1') {
            this.getAllFilterOptions();
        }
    };
    FilterOptions.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0424\u0438\u043B\u0442\u0440\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewFilterOption, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u0444\u0438\u043B\u0442\u044A\u0440"),
                            React.createElement("a", { onClick: this.toParentProduct },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(FilterOptionsList, { gridData: data, messages: this.messages, edit: this.toEditFilterOption, deleteItem: this.deleteItem }))))));
    };
    return FilterOptions;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(FilterOptions);



//////////////////
// WEBPACK FOOTER
// ./src/views/FilterOptions/FilterOptions.tsx
// module id = 354
// module chunks = 0